export const reviewerId = (reviewer: any): string =>
  typeof reviewer === 'string' ? reviewer : reviewer?.id || '';

export const getManagerIds = (users: any[]) =>
  new Set(users.map((user) => reviewerId(user?.reviewer)).filter(Boolean));

export const getDirectReports = (users: any[], managerId: string) =>
  users.filter((user) => reviewerId(user?.reviewer) === managerId);

export const isWorkspaceManager = (user: any, managerIds: Set<string>) =>
  managerIds.has(user?.id);

export const getWorkspaceAccessLabel = (user: any) =>
  user?.role === 'admin' ? 'Admin access' : 'Standard access';

export const getWorkspaceMemberRole = (user: any, managerIds: Set<string>) => {
  if (user?.role === 'admin') return 'Admin';
  if (isWorkspaceManager(user, managerIds)) return 'Manager';
  return 'Member';
};

export const getActiveWorkspaceAdmins = (users: any[]) => {
  const admins = new Map<string, any>();

  users
    .filter((user) => user?.role === 'admin' && user?.id)
    .forEach((user) => admins.set(user.id, user));

  return Array.from(admins.values());
};

export const isLastActiveWorkspaceAdmin = (user: any, activeUsers: any[]) =>
  user?.role === 'admin' && getActiveWorkspaceAdmins(activeUsers).length <= 1;
